module.exports = __webpack_public_path__ + "img/WernickeLogo.c98f3d1b.png";